import { io } from 'socket.io-client';
import { SOCKET_URL } from '../../config';

let socket = null;

// Conecta una sola vez, al primer uso — no se desconecta en unmount de componentes (los
// consumidores solo agregan/quitan listeners vía useSocket). Ver .claude/plans/
// frontend-architecture-refactor.md, sección "Socket.IO — singleton + hook" para el porqué.
//
// `guestToken` (integración main→dev, epic B1): un invitado de una sesión pública de terminal
// (PublicSessionView) no tiene cookie de sesión — entra con un JWT de invitado que viaja en
// `auth.guestToken` del handshake.
export function getSocket(guestToken = null) {
    if (!socket) {
        // El handshake se autentica con la cookie httpOnly de sesión —
        // withCredentials para que viaje cross-origin en dev.
        const opts = { autoConnect: true, withCredentials: true };
        if (guestToken) opts.auth = { guestToken };
        socket = io(SOCKET_URL, opts);
    } else if (guestToken && (!socket.connected || socket.auth?.guestToken !== guestToken)) {
        socket.auth = { ...socket.auth, guestToken };
        if (!socket.connected) socket.connect();
    }
    return socket;
}

// Añade/actualiza el guestToken en un socket ya creado (o lo crea con el token).
export function updateSocketGuestToken(guestToken) {
    if (socket) {
        socket.auth = { ...socket.auth, guestToken };
        if (!socket.connected) socket.connect();
        return socket;
    }
    return getSocket(guestToken);
}
